import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Modal,
  Box,
  Typography,
  Tooltip,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { modalStyle } from "../../Citizens/Recommendations/ModalComponentRecommendations.jsx";
import CloseIcon from "@mui/icons-material/Close";

const fieldMapping = [
  "age",
  "biological_sex",
  "ethnicity",
  "height",
  "weight",
  "primary_education",
  "university_education",
  "smoking",
  "alcohol",
  "red_meat_intake",
  "vegetable_intake",
  "fruit_intake",
  "diabetes",
  "family_history",
  "metabolic_syndrome",
  "ibd",
  "bmi",
];

function InfoTooltip({ iconSx, riskColor, ruleData, riskData, basicUserInfo }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { t } = useTranslation("riskInfo");

  // console.log("RAW RULE DATA IN INFOTOOLTIP", ruleData);
  // console.log("Basic user info in infotooltip: ", basicUserInfo);

  const parsedRuleFactor =
    Array.isArray(ruleData) &&
    ruleData[0]?.StratificationRulesModel?.rule_factor
      ? JSON.parse(ruleData[0].StratificationRulesModel.rule_factor)
      : {};
  const rule_risk =
    Array.isArray(ruleData) && ruleData[0]?.StratificationRulesModel.rule_risk;
  const activation_value =
    Array.isArray(ruleData) &&
    ruleData[0]?.StratificationRulesModel.activation_value;
  // console.log("parsedRuleFactor", parsedRuleFactor);

  const renderRuleData = () => {
    if (ruleData || riskData) {
      const mergedDt = fieldMapping.reduce((acc, key) => {
        let value =
          basicUserInfo?.[key] ?? parsedRuleFactor?.[key] ?? "No data";
        if (value !== "No data") {
          if (key === "height") value += " cm";
          if (key === "weight") value += " kg";
        }
        acc[key] = value;
        return acc;
      }, {});

      // console.log("mergedDt: ", mergedDt);

      return (
        <Box sx={{ mt: 2 }}>
          <TableContainer
            component={Paper}
            sx={{
              mt: 1,
              marginTop: "10px",
              border: "1px solid",
              maxHeight: "400px",
              overflow: "auto",
            }}
          >
            <Table size="small" aria-label="rule data table">
              <TableBody>
                {fieldMapping.map((key) => (
                  <TableRow key={key}>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ fontWeight: "bold" }}
                    >
                      {t(`fields.${key}`)}
                    </TableCell>
                    <TableCell>{mergedDt[key]}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ fontWeight: "bold" }}
                  >
                    {t("table.ruleRisk")}
                  </TableCell>

                  <TableCell sx={{ color: rule_risk ? riskColor : "black" }}>
                    {rule_risk || "No data"}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ fontWeight: "bold" }}
                  >
                     {t("table.activationValue")}
                  </TableCell>
                  <TableCell>{activation_value || "No data"}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      );
    }
    return <Typography variant="body2">{t("common.noRuleDataAvailable")}</Typography>;
  };

  return (
    <>
      <Tooltip
        title={rule_risk ? rule_risk : "Not calculated yet"}
        placement="right"
        arrow
      >
        <IconButton
          sx={{
            padding: 0,
            "&:hover": { backgroundColor: "unset" },
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleOpen();
          }}
        >
          <InfoIcon
            sx={{
              iconSx,
              width: "0.65em",
              paddingBottom: "10px",
            }}
          />
        </IconButton>
      </Tooltip>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="risk-modal-title"
        aria-describedby="risk-modal-description"
      >
        <Box sx={modalStyle}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography id="risk-modal-title" variant="h6" component="h2">
              {t("title")}
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          {renderRuleData()}
          <Typography
            id="risk-modal-description"
            sx={{ mt: 2 }}
            color={riskColor}
          >
            {rule_risk}
          </Typography>
        </Box>
      </Modal>
    </>
  );
}

export default InfoTooltip;
